export default {
    title: "မာကလာပင်",
    person_name: "မာကလာပင်, ကျနော်သည် ကျနော်ဖစ်သည်",
    person_desc: "မာကလာပင်, ကျနော်သည် ကျနော်ဖစ်သည်",
};
